export default __webpack_public_path__ + "media/images/logo-be1218ad03aa5fd4e3f46cb85f374cfc.svg";